import { useTranslation } from 'react-i18next';
import { Dialog, DialogActions, DialogContent, DialogContentText, Button } from '@mui/material';

const AlertDialog = ({ open, message, onClose }) => {
  const { t } = useTranslation();

  return (
    <Dialog open={open} onClose={onClose}>
      <DialogContent>
        <DialogContentText>{message}</DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose} color="primary" autoFocus>
          {t('OK')}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default AlertDialog;
